module.exports = "<script type=\"text/html\" id=\"propertyeditor-string\">\n  <input\n    class=\"form-control svd_editor_control\"\n    type=\"text\"\n    data-bind=\"value: koValue, disable: readOnly, attr: { placeholder: defaultValue, maxLength: koMaxLength, 'aria-label': displayName }\"\n    style=\"width:100%\"\n  />\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-string.html
// module id = 129
// module chunks = 0